var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ChristmasService } from 'services/holidays/ChristmasService';
import NoHolidayService from 'services/holidays/NoHolidayService';
import { container } from 'tsyringe';
import Vue from 'vue';
import { Component, Provide } from 'vue-property-decorator';
var defaultFavicon = require('common/assets/img/jobilla_favicon.ico');
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.console = console;
        _this.seasonalProviders = [
            ChristmasService,
            NoHolidayService,
        ];
        _this.holidayService = new NoHolidayService();
        return _this;
    }
    App.prototype.holidayHelper = function () {
        return this.holidayService;
    };
    App.prototype.mounted = function () {
        this.holidayService = container.resolve(this.seasonalProviders.find(function (provider) { return provider.applicable(); }));
    };
    __decorate([
        Provide(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], App.prototype, "holidayHelper", null);
    App = __decorate([
        Component({
            metaInfo: function () {
                return {
                    title: 'Jobilla',
                    link: [
                        { rel: 'icon', href: defaultFavicon },
                    ],
                };
            },
        })
    ], App);
    return App;
}(Vue));
export default App;
